import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../../../utils/spds/metadata';
import { BOOLEAN, NUMBER } from '../../../../../utils/component-validations';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import FilterButton from './base.gjs';
import Super from '../../../core/base.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Filter::Quick',
  description: 'Quick toggle filter button',
  meta: {
    ...pickArgs(COMPONENT_STATE_ARGS, ['disabled']).meta,
    ...pickArgs(CONTAINER_ARGS, ['fitContent']).meta,
    ...pickArgs(CONTENT_ARGS, ['text']).meta,
    count: {
      type: NUMBER,
      description: 'Number to display in badge',
      initialValue: 3,
    },
    filtered: {
      type: BOOLEAN,
      description: 'Initial filtered state',
      defaultValue: false,
    },
    onSelect: {
      ...ACTION_ARGS.meta.onClick,
      description: 'Action triggered when filter is toggled',
    },
    text: {
      ...CONTENT_ARGS.meta.text,
      defaultValue: '',
      initialValue: 'Quick filter',
    },
  },
  name: 'Quick Filter',
};

export default class SpdsActionButtonFilterQuick extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-button-filter-quick';

  @tracked filtered;

  constructor() {
    super(...arguments);

    this.arguments = this.composeArguments(this.constructor.metadata);

    this.filtered = this.args.filtered ?? getDefaultValueFromMetadata(METADATA, 'filtered');
  }

  get buttonText() {
    if (!this.count) return this.text;

    return [this.text, this.count].join(' ');
  }

  get count() {
    if (isEmpty(this.args.count)) return undefined;

    return `(${this.args.count})`;
  }

  get text() {
    return this.args.text ?? getDefaultValueFromMetadata(METADATA, 'text');
  }

  handleOnClick = () => {
    this.filtered = !this.filtered;
    this.args.onSelect?.(this.filtered);
  };

  <template>
    <FilterButton
      @filtered={{this.filtered}}
      @onClick={{this.handleOnClick}}
      class={{this.classes}}
      data-test-spds-action-button-filter-quick
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
      as |FB|
    >
      <FB.Trigger @disabled={{@disabled}} @fitContent={{@fitContent}}>
        {{this.buttonText}}
        {{yield}}
      </FB.Trigger>
    </FilterButton>
  </template>
}

export const ACTION_BUTTON_FILTER_QUICK_METADATA = SpdsActionButtonFilterQuick.metadata;
